
var ResultsTable = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2015",
      tbody, message, prevB, nextB, csvD, jsonD,
      fields, fieldMap,
      query = undefined,
      vsid = undefined,
      start = 0, num = 10,
      sorting = undefined,
      maxRows = Math.pow(2,31) - 1,
      listeners = [],
      modal = document.getElementById('modal');

  function click(code, system) {
    listeners.forEach(function (callback) {
      try {
          callback(code, system);
        } catch (err) {
          console.log(err);
        }
      });
  }

  function getProps (callback) {
    if (vsid || (query && "undefined" !== query)) {
      var limit = num, offset = start;
      if (sorting) {
        limit = maxRows;
        offset = 0;
      }
      // Display our spinner after a delay, just to provide feedback that 'something' is happening
      var timer = setTimeout(function () { modal.style.display = 'block'; }, 600),
          options = {
          includeDesignations: true,
          start: offset,
          limit: limit,
        };

      if (query) {
        options.url = query;
      } else {
        options.id = vsid;
      }

      Endpoint.expand(options,
        function(error, json) {
          clearTimeout(timer);
          modal.style.display = 'none';

          if (error) {
            if (422 == error.status && sorting) {
              alert("Reference Set too large to sort");
              d3.selectAll(".asc").classed("asc", false);
              sorting = undefined;
              update();
            } else {
              console.log(error, query);
              // alert("ERROR: " + error.response);
              var response;
              if (error.response) {
                response = JSON.parse(error.response);
              }
              if (response && response.issue) {
                callback([], -1, response.issue, query || vsid);
              } else {
                callback([], -1, [{severity: 'ERROR', diagnostics: error.response, }], query || vsid);
              }
            }
            return;
          }

          var rows = json.contains;
          if ('code' == sorting) {
            rows = rows.sort(function(a,b) {return a.code-b.code;})
                       .slice(start, start + num);
          } else if (sorting) {
            rows = rows.sort(function(a,b) {return a[sorting].localeCompare(b[sorting]);})
                       .slice(start, start + num);
          }
          callback(rows || [], json.total, undefined, query || vsid);

        }
      );
    } else {
      callback([], 0);
    }
  }

  function update(align) {
    getProps(function(rows, total, error, what) {

      var errs = tbody
        .selectAll(".error")
        .data(error || [], function (d) {return d.severity + d.diagnostics;});
      function addError(cb) {
        return errs.enter()
          .append("tr")
            .style("color", "darkred")
            .style("word-wrap", "break-word")
            .attr("class", "error")
            .append("td")
              .attr("colspan", fields.length)
              .text(cb);
      }
      addError(function (d) { return d.severity; }).style('text-align', 'center');
      addError(function (d) { return d.diagnostics.replace(/^\[[-0-9a-f]+\]:/, ""); });
      errs.exit().remove();

      var row = tbody
        .selectAll(".row")
        .data(rows, function(r) { return r.system+'_'+r.code; });

      row.enter()
        .append("tr")
        .attr("id", function(d) { return "row_"+d.code; })
        .attr("code", function(d) { return d.code; })
        .attr("system", function(d) { return d.system; })
        .style("cursor", "pointer")
        .on("click", function (d) { click(d.code, d.system); })
        .attr("class", "row")
        .each(function (d, i) {
          var row = d3.select(this);

          if (d.designation) {
            var fsn = d.designation.find(function (t) { return t.value && t.value.endsWith(')'); });
            d.fullySpecifiedName = (fsn || {}).value;
          }

          fields.forEach(function (k,i) {
            row.append("td")
              .style("text-align", (align && align(i)) ? "right" : "left")
              .text(d[k]);
          });

        });

      row.exit().remove();

      row.order();

      var n = Math.min(start + rows.length, total);
      var refset = what.match(/refset\/(.*)/)
      if (refset && refset.length === 2) {
        what = refset[1];
      }

      if (total >=0) {
        message.text('Refset: ' + what + '\n' + 'Showing '+Math.min(start+1,n)+' to '+n+' of '+total+' rows');
      } else {
        message.text('Refset: ' + what);
      }

      if (start > 0) {
        prevB.attr('onclick', 'ResultsTable.prev()').node().disabled = false;
      } else {
        prevB.attr('onclick', null).node().disabled = true;
      }

      if (n < total) {
        nextB.attr('onclick', 'ResultsTable.next()').node().disabled = false;
      } else {
        nextB.attr('onclick', null).node().disabled = true;
      }

    });
  }

  function mergeDefaults(options, defaults) {
    for (var key in defaults) {
      if(typeof options[key] === "undefined") options[key] = defaults[key];
    }
    return options;
  }

  function fn(name, suffix) {
    return name ? name.replace(/\s+/g, "_")+"."+suffix : null;
  }

  function doShowResults(q, id, filename, align) {
    query = q;
    vsid = id;
    start = 0;

    csvD.attr('href', Endpoint.getFindConceptsByQuery({
      id: vsid,
      query: query,
      fields: fields,
      format: 'csv',
      start: 0,
      limit: maxRows,
      filename: fn(filename, "csv"),
    }));

    jsonD.attr('href', Endpoint.getFindConceptsByQuery({
      id: vsid,
      query: query,
      fields: fields,
      format: 'json',
      start: 0,
      limit: maxRows,
      filename: fn(filename, "json"),
    }));

    update(align);
  }

  return {

    settings: {
      align: function (i) { return i == 0; },
      table: "#resultsTable",
      fieldMap: { fullySpecifiedName: "Fully Specified Name" },
      num: 20
    },

    init: function () {
      var s = this.settings,
          thead;

      fieldMap = mergeDefaults(
          s.fieldMap, {
            code: "SCTID",
            display: "Preferred Term",
          });
      fields = Object.keys(fieldMap);
      num = s.num;
      message = d3.select("#status");
      prevB = d3.select("#prev");
      nextB = d3.select("#next");
      csvD = d3.select("#bookmarkCSV");
      jsonD = d3.select("#bookmarkJSON");
      tbody = d3.select(s.table + " tbody");
      thead = d3.select(s.table + " thead").selectAll(".head").data(fields);

      thead.enter()
        .append("th")
        .style('width', function (d,i) { return i == 0 ? "10em" : null; })
        .classed("sortable", true)
        .on("click", function (d) {
          // clear previous
          d3.selectAll(".asc").classed("asc", false);
          if (sorting == d) { sorting = undefined; } else { d3.select(this).classed("asc", true); sorting = d; }
          update();
        })
        .text(function (d) { return fieldMap[d]; });
    },

    showResultsInstance: function (id, filename) {
      doShowResults(undefined, id, filename, this.settings.align);
    },

    showResults: function (q, filename) {
      doShowResults(q, undefined, filename, this.settings.align);
    },

    next: function () {
      start = start + num;
      update();
    },

    prev: function () {
      start = Math.max(0, start-num); 
      update();
    },

/*
    method: function (options, callback) {
      // mergeDefaults({}, options);

    },
*/

    addListener: function (listener) { listeners.push(listener); },
  };

}());

